<template>
  <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
    <div
      v-for="(item, index) in filters"
      :key="index"
    >
      <Component
        class="datatable-filter-item"
        :key="item.elastic_key"
        :is="defineComponent(item.type)"
        v-bind="item"
        @change="onChange(item, $event)"
        @reset="onReset(item)"
      />
    </div>
  </div>
</template>

<script>
// Components
import FilterSelect from './FilterSelect'
import FilterDate from './FilterDate'

export default {
  components: {
    FilterSelect,
    FilterDate
  },
  props: {
    filters: {
      type: Array
    }
  },
  methods: {
    defineComponent (type) {
      const components = {
        selector: 'FilterSelect',
        'date-range': 'FilterDate'
      }
      return components[type]
    },
    onChange (item, event) {
      item.pick = event
      const filters = this.filters.filter(el => el?.pick?.length)
      this.$emit('change', filters)
    },
    onReset (item) {
      item.pick = []
      const filters = this.filters.filter(el => el?.pick?.length)
      this.$emit('change', filters)
    }
  }
}
</script>
